import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.header`
	display: flex;
	background: linear-gradient(to right bottom, #FFB371, #FF9148);
	justify-content: space-between;
	align-items: center;
	padding-top: 85px;

	@supports (display: grid) {
		display: grid;
		background: none;
		padding-top: 0;
		min-height: 50vh;
		grid-template-columns: 35vw auto;
		grid-template-rows: 80px auto;
		align-items: initial;
		justify-content: initial;
		grid-template-areas: ${props =>
		props.hasImage
			? `'nav nav'
		  	   'img txt'`
			: `'nav nav'
		  	   'txt txt'`};
	}

	@media screen and (max-width: ${props => props.theme.mobileBreakPoint}) {
		min-height: ${props => (props.hasImage ? '100vh' : '50vh')};
		margin-bottom: 30px;
		grid-template-columns: 100vw;
		grid-template-rows: ${props =>
		props.hasImage ? '80px 1fr auto' : '80px auto'};
		grid-template-areas:
			'nav'
			'txt'
			'img';
	}
`;

const Img = styled.img`
	grid-area: img;
	max-width: 100%;
	max-height: 600px;
	object-fit: contain;
	object-position: left;
	margin-top: 5vh;
	padding-left: 10vw;
	padding-left: var(--side-margin);

	@media screen and (max-width: ${props => props.theme.mobileBreakPoint}) {
		padding: 0;
		width: 60vw;
		justify-self: center;
	}
`;

const Heading = styled.div`
	grid-area: txt;
	color: black;
	padding: 10vw;
	padding: var(--side-margin);
	padding-left: ${props => (props.hasImage ? '5vmin' : '10vw')};
	padding-left: ${props => (props.hasImage ? '5vmin' : 'var(--side-margin)')};
	text-align: ${props => (props.hasImage ? 'left' : 'center')};

	h1 {
		font-size: var(--fs-big);
		margin-top: 20px;
		margin-bottom: 20px;
	}

	h2 {
		font-size: var(--fs-x-big);
		font-weight: bold;
		margin-bottom: 20px;
		display: inline;
	}

	@media screen and (max-width: ${props => props.theme.tabletBreakPoint}) {
		h1{
			font-size: var(--fs-medium);
		}
		h2 {
			font-size: var(--fs-big);
		}
	}

	@media screen and (max-width: ${props => props.theme.mobileBreakPoint}) {
		text-align: center;
		align-self: ${props => (props.hasImage ? 'start' : 'center')};
	}
`;

const Background = styled.div`
	grid-row: 1 / -1;
	grid-column: 1 / -1;
	background: var(--primary-gradient);
	clip-path: polygon(0 0, 100% 0, 100% 70%, 0 90%);
	z-index: -1;
`;

const Header = ({ img, heading = '' }) => {
	const hasImage = !!img;

	return (
		<Container hasImage={hasImage}>
			{hasImage && <Img src={img.src} alt={img.alt} />}
			<Heading hasImage={hasImage}>
				{typeof heading === 'string' ? <h1>{heading}</h1> : heading()}
			</Heading>
			<Background />
		</Container>
	);
};

Header.propTypes = {
	heading: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
	img: PropTypes.shape({
		src: PropTypes.string.isRequired,
		alt: PropTypes.string.isRequired
	})
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js